import * as Yup from 'yup';
import { isValidPhoneNumber } from 'libphonenumber-js';

export const validationSchema = Yup.object({
  name: Yup.string().required('Name is required').min(3, 'Name must be at least 3 characters long'),
  phoneNumber: Yup.string()
    .required('Phone number is required')
    .test('isValidPhoneNumber', 'Invalid phone number', (value) =>
      value ? isValidPhoneNumber(value) : false,
    ),
  bestDay: Yup.string()
    .oneOf(['monday', 'tuesday', 'wednesday', 'thursday', 'friday', ''], 'Invalid day')
    .nullable(),
  bestTime: Yup.string().oneOf(['morning', 'afternoon', ''], 'Invalid time').nullable(),
});
